import {Legislation} from './../models/legislation.model';

import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import {
    FormArray,
    FormControl,
    FormGroup,
    NonNullableFormBuilder,
    ReactiveFormsModule,
} from '@angular/forms';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {TranslatePipe} from '@brunata-angular/util';
import {CheckboxGroupComponent} from '@brunata-angular/ui';

export type LegislationControl = FormGroup<{
    active: FormControl<boolean>;
    legislationId: FormControl<string>;
}>;
@Component({
    selector: 'app-edit-legislation',
    templateUrl: './edit-legislation.component.html',
    styleUrls: ['./edit-legislation.component.scss'],
    imports: [TranslatePipe, ReactiveFormsModule, NgbModule, CheckboxGroupComponent],
    providers: [ToastrService],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditLegislationComponent implements OnInit {
    @Input() legislations: Legislation[] = [];
    @Output() submitData = new EventEmitter<Legislation[]>();

    formGroup = this.formBuilder.group({
        legislations: new FormArray<LegislationControl>([]),
    });
    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: NonNullableFormBuilder,
    ) {}
    ngOnInit(): void {
        this.legislations.forEach(it => {
            const form = this.formBuilder.group(it);
            this.formGroup.controls.legislations.push(form);
        });
    }
    submit(): void {
        this.submitData.emit(this.formGroup.controls.legislations.getRawValue());
        this.activeModal.close();
    }
}
